module.exports = __webpack_public_path__ + "img/coupon_add.36fa46a6.png";